import React from 'react';
import { motion } from 'framer-motion';

const Card = ({ 
  children, 
  className = '', 
  hover = true,
  gradient = false,
  ...props 
}) => {
  const baseClasses = `bg-white rounded-2xl shadow-sm border border-neutral-100 overflow-hidden ${
    gradient ? 'bg-gradient-to-br from-white to-neutral-50' : ''
  }`;
  
  const hoverClasses = hover 
    ? 'hover:shadow-xl hover:border-primary-100 transition-all duration-300' 
    : '';
  
  const classes = `${baseClasses} ${hoverClasses} ${className}`;

  if (hover) {
    return (
      <motion.div
        className={classes}
        whileHover={{ y: -4, scale: 1.01 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
        {...props}
      >
        {children}
      </motion.div>
    );
  }

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

export default Card;